import _protected from "./protected";

export default {
    getBook: async(token, name) => {
        return await _protected.load(token, name);
    },
    getUsers: async(token) => {
        return await _protected.users(token);
    }
}